import { fragment, icon, node } from "~/util/dom";

export default class Item {
	_open: boolean;

	_dom: {
		container: DocumentFragment;
		wrapper: HTMLDivElement;
		content: HTMLDivElement;
		title: HTMLHeadingElement;
	};

	_onOpen: (item: Item) => void;

	constructor(doc, options) {
		this._open = options.open || false;
		this._onOpen = options.onOpen;
		this._dom = {
			container: fragment(),
			wrapper: node("div", { className: "wrapper" }),
			content: node("div", { className: "content" }),
			title: node("h2", { className: "title", innerHTML: doc.title }),
		};

		// jediny dokument
		if (options.single) {
			this._dom.content.appendChild(this._dom.title);
		// jeden z mnoha dokumentu
		} else {
			this._dom.title.addEventListener("click", this);
			this._dom.title.appendChild(icon("dropdown"));
			this._dom.container.appendChild(this._dom.title);
		}

		// zavreno
		if (this._open) {
			this._dom.title.classList.add("open");
		} else {
			this._dom.wrapper.classList.add("hidden");
		}

		this._dom.content.insertAdjacentHTML("beforeend", doc.body);
		this._dom.wrapper.appendChild(this._dom.content);
		this._dom.container.appendChild(this._dom.wrapper);
	}

	// eslint-disable-next-line class-methods-use-this
	destroy() {
	}

	get container() {
		return this._dom.container;
	}

	set open(open) {
		this._open = open;

		this._dom.wrapper.classList[open ? "remove" : "add"]("hidden");
		this._dom.title.classList[open ? "add" : "remove"]("open");
	}

	handleEvent() {
		if (!this._open) {
			this._onOpen(this);
		}
	}
}
